import { z } from 'zod';
/**
 * Cadence settings — when the agent ships the daily briefing, when L10
 * fires, when the quarterly Rocks board auto-drafts. Stored as wall-clock
 * strings + tz so DST transitions don't shift the briefing time the CEO
 * actually wakes up to.
 *
 * Briefing-skip-days defaults to ['Sat', 'Sun'] because the L10 cadence
 * targets a weekday rhythm; CEOs that work the weekend can clear the
 * skip list.
 *
 * `quarterAutoDraftDaysBefore` controls how far in advance the agent
 * starts assembling the next quarter's Rock candidates. 14 is the EOS
 * default — two weeks gives the CEO a working draft before quarter-end.
 */
// Domain-prefixed name so the shared barrel doesn't expose a generic
// `Weekday` symbol — schema collisions in a flat re-export are easy
// to miss until a downstream consumer breaks.
export const CadenceWeekday = z.enum(['Mon', 'Tue', 'Wed', 'Thu', 'Fri']);
export const SkipDay = z.enum(['Sat', 'Sun']);
export const BriefingDelivery = z.enum(['inApp', 'email', 'slack']);
export const QuarterStart = z.enum(['Jan 1', 'Apr 1', 'Jul 1', 'Oct 1']);
export const CadenceSettings = z.object({
    /** Wall-clock time, e.g. "07:00". */
    briefingTime: z.string(),
    /** IANA tz, e.g. "America/New_York". */
    briefingTz: z.string(),
    briefingDelivery: z.array(BriefingDelivery),
    briefingSkipDays: z.array(SkipDay).default(['Sat', 'Sun']),
    l10Day: CadenceWeekday,
    /** Wall-clock time, e.g. "09:00". */
    l10Time: z.string(),
    l10AutoDraft: z.boolean(),
    quarterStart: QuarterStart,
    quarterAutoDraftDaysBefore: z.number().int().nonnegative().default(14),
});
